module.exports = __webpack_public_path__ + "static/img/227_TO8_1968_og.e4586c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/227_TO8_1968_og.jpg
// module id = Dh8r
// module chunks = 0